// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-stats {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 250px;
  height: 70px;
  padding: 5px;
  margin: 10px 0px 30px 0px;
  font-weight: var(--roboto-black);
  font-size: 1.6rem;
  background-color: var(--third-color);
  color: var(--primary-color);
}

.current-question,
.current-score {
  font-size: 2.5rem;
  color: var(--primary-text);
  margin-left: 10px;
}

.quiz-question-icon,
.quiz-score-icon {
  margin-right: 15px;
}

.difficulty-display {
  font-size: 1.1rem;
  color: var(--secondary-text);
  margin-bottom: 20px;
  font-style: italic;
}

.difficulty-display-span {
  text-transform: uppercase;
  color: var(--secondary-color);
}

.elapsed-time-container {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--secondary-color);
}

.elapsed-time {
  margin: 15px;
  font-size: 1.3rem;
}

.quiz-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}

.quiz-question {
  font-size: 3rem;
  font-weight: var(--roboto-medium);
  margin: 50px 20px 70px 20px;
}

.quiz-options {
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: repeat(2, auto);
  gap: 50px;
}

.quiz-options button {
  text-align: center;
  text-decoration: none;
  border: 2px solid transparent;
  border-radius: 10px;
  font-family: "Roboto", sans-serif;
  font-weight: var(--roboto-bold);
  color: var(--bg-color);
  min-width: 300px;
  min-height: 70px;
  cursor: pointer;
  font-size: 1.5rem;
  background-color: var(--primary-text);
  border-color: var(--primary-text);
  padding: 10px;
}

.quiz-options button:disabled,
.quiz-options button[disabled] {
  cursor: not-allowed;
}

.quiz-options button:not([disabled]):hover {
  background-color: var(--third-color);
  color: var(--primary-text);
  animation: pulse 1s infinite ease-in-out;
  border-color: var(--third-color);
}

.correct-answer {
  background-color: var(--green-color);
  color: var(--primary-text);
  animation: flicker 1s infinite;
}

button.wrong-answer {
  background-color: var(--red-color);
  color: var(--primary-text);
}

@keyframes flicker {
  0%,
  100% {
    background-color: var(--green-color);
    color: var(--primary-text);
  }
  50% {
    background-color: transparent;
    color: var(--primary-text);
  }
}

.answer-big-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
  gap: 50px;
}

.show-hide-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 50px 20px 0px 20px;
}

.show-hide-container button {
  border: none;
  padding: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-weight: var(--roboto-regular);
  color: var(--secondary-color);
  font-size: 20px;
  min-width: 200px;
  font-size: 1.2rem;
}

.previous-question {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font: var(--roboto-bold);
  color: var(--secondary-text);
  font-size: 1rem;
  margin-top: 30px;
}

.previous-question-text {
  font-size: 1rem;
  margin-bottom: 10px;
  font-style: italic;
}

.previous-question-answer {
  margin-bottom: 5px;
}

.flow-toggle-container,
.next-finish-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 5px;
  margin: 30px 20px 10px 20px;
}

.flow-toggle-button,
.next-question-button,
.finish-quiz-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background-color: var(--primary-color);
  text-align: center;
  text-decoration: none;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-weight: var(--roboto-bold);
  color: var(--bg-color);
  font-size: 1.1rem;
  width: 230px;
  height: 50px;
  min-width: 330px;
}

.flow-toggle-button:hover,
.next-question-button:hover,
.finish-quiz-button:hover {
  background-color: var(--secondary-color);
  color: var(--primary-text);
}

.flow-toggle-button:disabled,
.flow-toggle-button[disabled],
.next-question-button:disabled,
.next-question-button[disabled],
.finish-quiz-button:disabled,
.finish-quiz-button[disabled] {
  background-color: lightgray;
  color: gray;
  cursor: not-allowed;
  opacity: 0.5;
}

.next-finish-container {
  padding: 5px;
  margin: 0px;
}

.next-question-button,
.finish-quiz-button {
  margin: 70px 20px 10px 20px;
  width: 100px;
  height: 50px;
  min-width: 200px;
}

.correct {
  color: var(--green-color);
}

.incorrect {
  color: var(--red-color);
}

@media screen and (max-width: 1000px) {
  .quiz-stats {
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-top: 10px;
    margin-bottom: 50px;
    height: auto;
    font-weight: var(--roboto-black);
    font-size: 1.3rem;
  }

  .current-question,
  .current-score {
    font-size: 2rem;
  }

  .quiz-question {
    font-size: 2rem;
    font-weight: var(--roboto-medium);
    margin: 20px 10px 40px 10px;
  }

  .quiz-options {
    grid-template-columns: auto;
    gap: 30px;
  }

  .quiz-options button {
    font-weight: var(--roboto-medium);
    min-width: 150px;
    min-height: 60px;
    font-size: 1.2rem;
    padding: 10px;
  }

  .difficulty-display {
    font-size: 1rem;
  }

  .quiz-options button:not([disabled]):hover {
    background-color: var(--primary-text);
    border-color: var(--primary-text);
    animation: none;
    color: var(--bg-color);
  }

  .show-hide-container {
    margin-top: 60px;
  }

  .previous-question {
    margin-top: 20px;
    font-size: 1rem;
    margin-bottom: 0px;
  }

  .flow-toggle-container {
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .flow-toggle-button {
    width: 100%;
    font-size: 1rem;
    min-width: 250px;
  }
}

@media screen and (max-width: 500px) {
  .quiz-stats {
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 7px;
    margin-bottom: 40px;
    font-weight: var(--roboto-medium);
    font-size: 1.1rem;
  }

  .current-question,
  .current-score {
    font-size: 1.7rem;
  }

  .quiz-question {
    font-size: 1.5rem;
    font-weight: var(--roboto-medium);
  }

  .quiz-options {
    grid-template-columns: auto;
  }

  .quiz-options button {
    font-weight: var(--roboto-medium);
    min-width: 150px;
    min-height: 50px;
    font-size: 1rem;
    padding: 10px;
  }

  .quiz-options button:not([disabled]):hover {
    background-color: var(--primary-text);
    border-color: var(--primary-text);
    animation: none;
    color: var(--bg-color);
  }

  .show-hide-container button {
    font-size: 1rem;
  }

  .previous-question {
    margin-top: 30px;
    font-size: 1rem;
    margin-bottom: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/triviaQuestions/TriviaQuestions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;EAEE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,iCAAiC;EACjC,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,iCAAiC;EACjC,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,oCAAoC;IACpC,0BAA0B;EAC5B;EACA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;;;;;;EAME,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,iCAAiC;IACjC,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,iCAAiC;IACjC,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".quiz-stats {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 250px;\r\n  height: 70px;\r\n  padding: 5px;\r\n  margin: 10px 0px 30px 0px;\r\n  font-weight: var(--roboto-black);\r\n  font-size: 1.6rem;\r\n  background-color: var(--third-color);\r\n  color: var(--primary-color);\r\n}\r\n\r\n.current-question,\r\n.current-score {\r\n  font-size: 2.5rem;\r\n  color: var(--primary-text);\r\n  margin-left: 10px;\r\n}\r\n\r\n.quiz-question-icon,\r\n.quiz-score-icon {\r\n  margin-right: 15px;\r\n}\r\n\r\n.difficulty-display {\r\n  font-size: 1.1rem;\r\n  color: var(--secondary-text);\r\n  margin-bottom: 20px;\r\n  font-style: italic;\r\n}\r\n\r\n.difficulty-display-span {\r\n  text-transform: uppercase;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.elapsed-time-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.elapsed-time {\r\n  margin: 15px;\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.quiz-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.quiz-question {\r\n  font-size: 3rem;\r\n  font-weight: var(--roboto-medium);\r\n  margin: 50px 20px 70px 20px;\r\n}\r\n\r\n.quiz-options {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, auto);\r\n  grid-template-rows: repeat(2, auto);\r\n  gap: 50px;\r\n}\r\n\r\n.quiz-options button {\r\n  text-align: center;\r\n  text-decoration: none;\r\n  border: 2px solid transparent;\r\n  border-radius: 10px;\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: var(--roboto-bold);\r\n  color: var(--bg-color);\r\n  min-width: 300px;\r\n  min-height: 70px;\r\n  cursor: pointer;\r\n  font-size: 1.5rem;\r\n  background-color: var(--primary-text);\r\n  border-color: var(--primary-text);\r\n  padding: 10px;\r\n}\r\n\r\n.quiz-options button:disabled,\r\n.quiz-options button[disabled] {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.quiz-options button:not([disabled]):hover {\r\n  background-color: var(--third-color);\r\n  color: var(--primary-text);\r\n  animation: pulse 1s infinite ease-in-out;\r\n  border-color: var(--third-color);\r\n}\r\n\r\n.correct-answer {\r\n  background-color: var(--green-color);\r\n  color: var(--primary-text);\r\n  animation: flicker 1s infinite;\r\n}\r\n\r\nbutton.wrong-answer {\r\n  background-color: var(--red-color);\r\n  color: var(--primary-text);\r\n}\r\n\r\n@keyframes flicker {\r\n  0%,\r\n  100% {\r\n    background-color: var(--green-color);\r\n    color: var(--primary-text);\r\n  }\r\n  50% {\r\n    background-color: transparent;\r\n    color: var(--primary-text);\r\n  }\r\n}\r\n\r\n.answer-big-icons {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 200px;\r\n  gap: 50px;\r\n}\r\n\r\n.show-hide-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  margin: 50px 20px 0px 20px;\r\n}\r\n\r\n.show-hide-container button {\r\n  border: none;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 10px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: var(--roboto-regular);\r\n  color: var(--secondary-color);\r\n  font-size: 20px;\r\n  min-width: 200px;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.previous-question {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  font: var(--roboto-bold);\r\n  color: var(--secondary-text);\r\n  font-size: 1rem;\r\n  margin-top: 30px;\r\n}\r\n\r\n.previous-question-text {\r\n  font-size: 1rem;\r\n  margin-bottom: 10px;\r\n  font-style: italic;\r\n}\r\n\r\n.previous-question-answer {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.flow-toggle-container,\r\n.next-finish-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 40px;\r\n  padding: 5px;\r\n  margin: 30px 20px 10px 20px;\r\n}\r\n\r\n.flow-toggle-button,\r\n.next-question-button,\r\n.finish-quiz-button {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n  background-color: var(--primary-color);\r\n  text-align: center;\r\n  text-decoration: none;\r\n  border: 2px solid transparent;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: var(--roboto-bold);\r\n  color: var(--bg-color);\r\n  font-size: 1.1rem;\r\n  width: 230px;\r\n  height: 50px;\r\n  min-width: 330px;\r\n}\r\n\r\n.flow-toggle-button:hover,\r\n.next-question-button:hover,\r\n.finish-quiz-button:hover {\r\n  background-color: var(--secondary-color);\r\n  color: var(--primary-text);\r\n}\r\n\r\n.flow-toggle-button:disabled,\r\n.flow-toggle-button[disabled],\r\n.next-question-button:disabled,\r\n.next-question-button[disabled],\r\n.finish-quiz-button:disabled,\r\n.finish-quiz-button[disabled] {\r\n  background-color: lightgray;\r\n  color: gray;\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.next-finish-container {\r\n  padding: 5px;\r\n  margin: 0px;\r\n}\r\n\r\n.next-question-button,\r\n.finish-quiz-button {\r\n  margin: 70px 20px 10px 20px;\r\n  width: 100px;\r\n  height: 50px;\r\n  min-width: 200px;\r\n}\r\n\r\n.correct {\r\n  color: var(--green-color);\r\n}\r\n\r\n.incorrect {\r\n  color: var(--red-color);\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n  .quiz-stats {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 15px;\r\n    margin-top: 10px;\r\n    margin-bottom: 50px;\r\n    height: auto;\r\n    font-weight: var(--roboto-black);\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .current-question,\r\n  .current-score {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .quiz-question {\r\n    font-size: 2rem;\r\n    font-weight: var(--roboto-medium);\r\n    margin: 20px 10px 40px 10px;\r\n  }\r\n\r\n  .quiz-options {\r\n    grid-template-columns: auto;\r\n    gap: 30px;\r\n  }\r\n\r\n  .quiz-options button {\r\n    font-weight: var(--roboto-medium);\r\n    min-width: 150px;\r\n    min-height: 60px;\r\n    font-size: 1.2rem;\r\n    padding: 10px;\r\n  }\r\n\r\n  .difficulty-display {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .quiz-options button:not([disabled]):hover {\r\n    background-color: var(--primary-text);\r\n    border-color: var(--primary-text);\r\n    animation: none;\r\n    color: var(--bg-color);\r\n  }\r\n\r\n  .show-hide-container {\r\n    margin-top: 60px;\r\n  }\r\n\r\n  .previous-question {\r\n    margin-top: 20px;\r\n    font-size: 1rem;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .flow-toggle-container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-top: 30px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .flow-toggle-button {\r\n    width: 100%;\r\n    font-size: 1rem;\r\n    min-width: 250px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  .quiz-stats {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-top: 7px;\r\n    margin-bottom: 40px;\r\n    font-weight: var(--roboto-medium);\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .current-question,\r\n  .current-score {\r\n    font-size: 1.7rem;\r\n  }\r\n\r\n  .quiz-question {\r\n    font-size: 1.5rem;\r\n    font-weight: var(--roboto-medium);\r\n  }\r\n\r\n  .quiz-options {\r\n    grid-template-columns: auto;\r\n  }\r\n\r\n  .quiz-options button {\r\n    font-weight: var(--roboto-medium);\r\n    min-width: 150px;\r\n    min-height: 50px;\r\n    font-size: 1rem;\r\n    padding: 10px;\r\n  }\r\n\r\n  .quiz-options button:not([disabled]):hover {\r\n    background-color: var(--primary-text);\r\n    border-color: var(--primary-text);\r\n    animation: none;\r\n    color: var(--bg-color);\r\n  }\r\n\r\n  .show-hide-container button {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .previous-question {\r\n    margin-top: 30px;\r\n    font-size: 1rem;\r\n    margin-bottom: 0px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
